module.exports = __webpack_public_path__ + "img/03.85cd1c4a.png";